<div class="main-content" [class.client-settings-panel-mode]="isPanelMode">
	<div class="row" *ngIf="!isPanelMode">
		<div class="col-md-8">
			<button class="btn btn-default mb10" [routerLink]="['/admin/clients']">Back</button>
		</div>
	</div>
	<div class="full-div space-20"></div>
	<div class="row">
		<div class="col-md-12 mb-2" style="border-bottom: 1px solid #65615c">
			<h5 style="margin-bottom: 0">{{ item.id ? 'Modify Client Information' : 'Create Client Information' }}</h5>
		</div>
		<div class="col-md-12 justify-content-left">
			<div class="card">
				<div class="card-body">
					<p-tabView [(activeIndex)]="activeIndex" (activeIndexChange)="onTabChange($event)">
						<p-tabPanel header="Client Information">
							<form novalidate (ngSubmit)="onClientFormSubmit()" [formGroup]="clientForm" class="form-horizontal">
								<div class="row">
									<div class="col-md-4 col-lg-4">
										<label>Name</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="name"
												[ngClass]="{ 'has-error': !f.name.valid && submitted }"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Friendly Id</label>
										<div class="form-group">
											<input type="number" class="form-control" formControlName="externalId" [readonly]="true" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Password Min Length</label>
										<div class="form-group">
											<input
												type="number"
												class="form-control"
												formControlName="passwordLength"
												[ngClass]="{ 'has-error': !f.passwordLength.valid && submitted }"
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4 col-lg-4">
										<label>Description</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="description"
												[ngClass]="{ 'has-error': !f.description.valid && submitted }"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Website Url</label>
										<div class="form-group" [ngClass]="{ 'has-error': !f.webSiteUrl.valid && submitted }">
											<input type="text" class="form-control" formControlName="webSiteUrl" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Password Expiry Days</label>
										<div class="form-group" [ngClass]="{ 'has-error': !f.passwordExpiryDays.valid && submitted }">
											<input type="number" class="form-control" formControlName="passwordExpiryDays" />
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4 col-lg-4">
										<label class="required">Address </label>
										<div class="form-group">
											<input
												type="text"
												[ngClass]="{
													'has-error': !f.address.valid && submitted
												}"
												class="form-control"
												formControlName="address"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Address Line 2 </label>
										<div class="form-group">
											<input
												type="text"
												[ngClass]="{
													'has-error': !f.addressLine2.valid && submitted
												}"
												class="form-control"
												formControlName="addressLine2"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required">City </label>
										<div class="form-group">
											<input
												type="text"
												[ngClass]="{
													'has-error': !f.city.valid && submitted
												}"
												class="form-control"
												formControlName="city"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required"> State</label>
										<div class="form-group" [ngClass]="{ 'has-error': !f.state.valid && submitted }">
											<select class="form-control ddl-select" formControlName="state">
												<option>-Select State-</option>
												<option [value]="s.abbreviation" *ngFor="let s of usStates">
													{{ s.name }}
												</option>
											</select>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required"> Country</label>
										<div class="form-group">
											<input
												formControlName="country"
												[ngClass]="{ 'has-error': !f.country.valid && submitted }"
												type="text"
												class="form-control"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required">Zip </label>
										<div class="form-group">
											<input
												type="text"
												[ngClass]="{
													'has-error': !f.zipCode.valid && submitted
												}"
												class="form-control"
												formControlName="zipCode"
											/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4 col-sm-6 col-lg-3">
										<div class="form-check mt-3">
											<div class="form-check">
												<label class="form-check-label">
													<input type="checkbox" formControlName="enableMFA" /> Enable MFA
													<span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-6 col-lg-3">
										<div class="form-check mt-3">
											<div class="form-check">
												<label class="form-check-label">
													<input type="checkbox" formControlName="disableRegularLogin" /> Disable Regular Login
													<span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
								</div>
								<div class="card-footerp-l-r-0 d-flex justify-content-between align-items-center">
									<button type="submit" [disabled]="clientForm.invalid" class="btn btn-info btn-round">
										{{ item.id ? 'Save Client' : 'Submit' }}
									</button>
									<button
										type="button"
										class="btn btn-default btn-round"
										*ngIf="item.id && userService.isAdmin()"
										(click)="manageEmailWhitelist()"
									>
										Manage Email Whitelist
									</button>
								</div>
							</form>
						</p-tabPanel>
						<p-tabPanel header="Client Contact" [disabled]="!item.id">
							<form
								novalidate
								(ngSubmit)="onClientContactSubmit()"
								[formGroup]="clientContactForm"
								class="form-horizontal"
							>
								<div class="row">
									<div class="col-md-4 col-lg-4">
										<label class="required">Contact Name </label>
										<div class="form-group" [ngClass]="{ 'has-error': !cf.contactName.valid && contactSubmitted }">
											<input type="text" class="form-control" formControlName="contactName" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required">Title </label>
										<div class="form-group" [ngClass]="{ 'has-error': !cf.title.valid && contactSubmitted }">
											<input type="text" class="form-control" formControlName="title" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required">Phone Number </label>
										<div
											class="form-group"
											[ngClass]="{
												'has-error': !cf.phone.valid && contactSubmitted
											}"
										>
											<input mask="000-000-0000" type="text" class="form-control" formControlName="phone" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Phone Extention </label>
										<div
											class="form-group"
											[ngClass]="{
												'has-error': !cf.extension.valid && contactSubmitted
											}"
										>
											<input type="text" class="form-control" formControlName="extension" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Fax Number </label>
										<div
											class="form-group"
											[ngClass]="{
												'has-error': !cf.fax.valid && contactSubmitted
											}"
										>
											<input mask="000-000-0000" type="text" class="form-control" formControlName="fax" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required">Email Address </label>
										<div
											class="form-group"
											[ngClass]="{
												'has-error': !cf.emailAddress.valid && contactSubmitted
											}"
										>
											<input type="Email" class="form-control" formControlName="emailAddress" />
										</div>
									</div>
								</div>
								<div class="card-footerp-l-r-0">
									<button
										type="submit"
										[disabled]="clientContactForm.invalid || clientContactForm.disabled"
										class="btn btn-info btn-round"
									>
										{{ item.id ? 'Save' : 'Submit' }}
									</button>
								</div>
							</form>
						</p-tabPanel>
						<p-tabPanel header="Tax Information" [disabled]="!item.id">
							<form
								novalidate
								(ngSubmit)="onClientTaxInfoSubmit()"
								[formGroup]="clientTaxInfoForm"
								class="form-horizontal"
							>
								<div class="row">
									<div class="col-md-1 col-sm-2 col-lg-1">
										<div class="form-check mt-3">
											<div class="form-check">
												<label class="form-check-label">
													<input type="checkbox" formControlName="isEIN" />Is EIN #
													<span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-3 col-lg-3">
										<label class="required">EIN or SSN # </label>
										<div class="form-group" [ngClass]="{ 'has-error': !ct.einOrSSN.valid && taxInfoSubmitted }">
											<input type="text" class="form-control" formControlName="einOrSSN" />
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required"> Business Type</label>
										<div class="form-group" [ngClass]="{ 'has-error': !ct.businessType.valid && taxInfoSubmitted }">
											<select class="form-control ddl-select" formControlName="businessType">
												<option value="">-Select One-</option>
												<option value="CORP">CORPORATION</option>
												<option value="ESTE">ESTATES</option>
												<option value="EORG">EXEMPT ORGANIZATION</option>
												<option value="PART">PARTNERSHIP</option>
												<option value="SPRO">SOLE PROPRIETOR</option>
											</select>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required"> Kind of Employer</label>
										<div class="form-group" [ngClass]="{ 'has-error': !ct.kindOfEmployer.valid && taxInfoSubmitted }">
											<select class="form-control ddl-select" formControlName="kindOfEmployer">
												<option value="">-Select One-</option>
												<option value="FEDERALGOVT">FEDERAL GOVERNMENT</option>
												<option value="NONGOVT501C">NON GOVERNMENT 501C</option>
												<option value="NONEAPPLY">NONE APPLY</option>
												<option value="STATEORLOCAL501C">STATE OR LOCAL 501C</option>
												<option value="STATEORLOCALNON501C">STATE OR LOCAL NON 501C</option>
											</select>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label class="required"> Kind of Payer</label>
										<div class="form-group" [ngClass]="{ 'has-error': !ct.kindOfPayer.valid && taxInfoSubmitted }">
											<select class="form-control ddl-select" formControlName="kindOfPayer">
												<option value="">-Select One-</option>
												<option value="AGRICULTURAL943">AGRICULTURAL 943</option>
												<option value="HOUSEHOLD">HOUSEHOLD</option>
												<option value="MEDICAREQUALGOVEM">MEDICARE QUAL GOV EM</option>
												<option value="MILITARY">MILITARY</option>
												<option value="RAILROADFORMCT1">RAILROAD FORM CT1</option>
												<option value="REGULAR941">REGULAR 941</option>
												<option value="REGULAR944">REGULAR 944</option>
											</select>
										</div>
									</div>
									<div class="col-md-3 col-lg-3">
										<label>Signing Authority Name</label>
										<div
											class="form-group"
											[ngClass]="{ 'has-error': !ct.signingAuthorityNm.valid && taxInfoSubmitted }"
										>
											<input type="text" class="form-control" formControlName="signingAuthorityNm" />
										</div>
									</div>
									<div class="col-md-3 col-lg-3">
										<label>Signing Authority Phone #</label>
										<div
											class="form-group"
											[ngClass]="{ 'has-error': !ct.signingAuthorityPhnNum.valid && taxInfoSubmitted }"
										>
											<input
												mask="000-000-0000"
												type="text"
												class="form-control"
												formControlName="signingAuthorityPhnNum"
											/>
										</div>
									</div>
									<div class="col-md-4 col-lg-4">
										<label>Business Member Type</label>
										<div
											class="form-group"
											[ngClass]="{ 'has-error': !ct.businessMemberType.valid && taxInfoSubmitted }"
										>
											<select class="form-control ddl-select" formControlName="businessMemberType">
												<option value="">-Select One-</option>
												<option value="CORPORATESECRETARY">CORPORATE SECRETARY</option>
												<option value="SECRETARYTREASURER">SECRETARY TREASURER</option>
												<option value="PARTNER">PARTNER</option>
												<option value="GENERALPARTNER">GENERAL PARTNER</option>
												<option value="LIMITEDPARTNER">LIMITED PARTNER</option>
												<option value="LLCMEMBER">LLC MEMBER</option>
												<option value="MANAGINGMEMBER">MANAGING MEMBER</option>
												<option value="MANAGER">MANAGER</option>
												<option value="TAXMATTERPARTNER">TAX MATTER PARTNER</option>
												<option value="PRESIDENT">PRESIDENT</option>
												<option value="VICEPRESIDENT">VICE PRESIDENT</option>
												<option value="CORPORATETREASURER">CORPORATE TREASURER</option>
												<option value="TREASURER">TREASURER</option>
												<option value="ASSISTANTTREASURER">ASSISTANT TREASURER</option>
												<option value="CHIEFACCOUNTINGOFFICER">CHIEF ACCOUNTING OFFICER</option>
												<option value="CHIEFEXECUTIVEOFFICER">CHIEFEXECUTIVEOFFICER</option>
												<option value="CHIEFFINANCIALOFFICER">CHIEF FINANCIAL OFFICER</option>
												<option value="TAXOFFICER">TAX OFFICER</option>
												<option value="CHIEFOPERATINGOFFICER">CHIEF OPERATING OFFICER</option>
												<option value="CORPORATEOFFICER">CORPORATE OFFICER</option>
												<option value="EXECUTIVEDIRECTOR">EXECUTIVE DIRECTOR</option>
												<option value="DIRECTOR">DIRECTOR</option>
												<option value="CHAIRMAN">CHAIRMAN</option>
												<option value="EXECUTIVEADMINISTRATOR">EXECUTIVE ADMINISTRATOR</option>
												<option value="RECEIVER">RECEIVER</option>
												<option value="PASTOR">PASTOR</option>
												<option value="ASSISTANTTORELIGIOUSLEADER">ASSISTANT TO RELIGIOUS LEADER</option>
												<option value="REVEREND">REVEREND</option>
												<option value="PRIEST">PRIEST</option>
												<option value="MINISTER">MINISTER</option>
												<option value="RABBI">RABBI</option>
												<option value="LEADEROFRELIGIOUSORGANIZATION">LEADER OF RELIGIOUS ORGANIZATION</option>
												<option value="SECRETARY">SECRETARY</option>
												<option value="DIRECTOROFTAXATION">DIRECTOR OF TAXATION</option>
												<option value="DIRECTOROFPERSONNEL">DIRECTOR OF PERSONNEL</option>
												<option value="ADMINISTRATOR">ADMINISTRATOR</option>
												<option value="EXECUTOR">EXECUTOR</option>
												<option value="TRUSTEE">TRUSTEE</option>
												<option value="FIDUCIARY">FIDUCIARY</option>
												<option value="OWNER">OWNER</option>
												<option value="SOLEPROPRIETOR">SOLE PROPRIETOR</option>
												<option value="MEMBER">MEMBER</option>
												<option value="SOLEMEMBER">SOLE MEMBER</option>
											</select>
										</div>
									</div>
									<div class="col-md-3 col-lg-3" *ngIf="!canGenerateTaxBandit">
										<label>Tax Bandit Business Id</label>
										<div class="form-group">
											<input type="text" readonly class="form-control" formControlName="referenceId" />
										</div>
									</div>
								</div>
								<div class="card-footerp-l-r-0">
									<button
										type="submit"
										[disabled]="clientTaxInfoForm.invalid || clientTaxInfoForm.disabled"
										class="btn btn-info btn-round"
									>
										{{ item.id ? 'Save' : 'Submit' }}
									</button>
								</div>
								<div class="row">
									<div *ngIf="userService.isAdmin() && canGenerateTaxBandit" class="col-md-2 pull-right">
										<button (click)="generateTaxBandit()" class="btn btn-sm mb10">Generate Tax Bandit Business</button>
									</div>
								</div>
							</form>
						</p-tabPanel>

						<p-tabPanel header="Client Config" [disabled]="!item.id" (selected)="initializeConfig()">
							<div *ngIf="loadingConfigData" class="row">
								<div class="col-md-6 p-2" *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8, 9]">
									<p-skeleton styleClass="mb-2"></p-skeleton>
									<p-skeleton width="10rem" styleClass="mb-3"></p-skeleton>
								</div>
							</div>
							<form *ngIf="!loadingConfigData" novalidate [formGroup]="clientConfigForm" class="form-horizontal">
								<div class="row">
									<div class="col-md-6 p-2">
										<label>Vendor Invoice Creation</label>
										<div
											*ngIf="configForm.vendorInvoiceCreationType.value !== 'groups'"
											class="form-group"
											[ngClass]="{ 'has-error': !configForm.vendorInvoiceCreation.valid && clientConfigSubmitted }"
										>
											<select class="form-control" formControlName="vendorInvoiceCreation">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.id" *ngFor="let item of users">
													{{ item.firstName }} {{ item.middleName }}
													{{ item.lastName }}
												</option>
											</select>
										</div>
										<div
											*ngIf="configForm.vendorInvoiceCreationType.value === 'groups'"
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.vendorInvoiceCreationGroupId.valid && clientConfigSubmitted
											}"
										>
											<select class="form-control" formControlName="vendorInvoiceCreationGroupId">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.oldId" *ngFor="let item of groups">
													{{ item.name }}
												</option>
											</select>
										</div>
										<p-selectButton
											[options]="types"
											formControlName="vendorInvoiceCreationType"
											optionLabel="label"
											optionValue="value"
											(onChange)="onVendorInvoiceCreationTypeChange()"
										></p-selectButton>
									</div>
									<div class="col-md-6 p-2">
										<label>Vendor Registration Creation</label>
										<div
											*ngIf="configForm.vendorRegistrationCreationType.value !== 'groups'"
											class="form-group"
											[ngClass]="{ 'has-error': !configForm.vendorRegistrationCreation.valid && clientConfigSubmitted }"
										>
											<select class="form-control" formControlName="vendorRegistrationCreation">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.id" *ngFor="let item of users">
													{{ item.firstName }} {{ item.middleName }}
													{{ item.lastName }}
												</option>
											</select>
										</div>
										<div
											*ngIf="configForm.vendorRegistrationCreationType.value === 'groups'"
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.vendorRegistrationCreationGroupId.valid && clientConfigSubmitted
											}"
										>
											<select class="form-control" formControlName="vendorRegistrationCreationGroupId">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.oldId" *ngFor="let item of groups">
													{{ item.name }}
												</option>
											</select>
										</div>
										<p-selectButton
											[options]="types"
											formControlName="vendorRegistrationCreationType"
											optionLabel="label"
											optionValue="value"
											(onChange)="onVendorRegistrationCreationTypeChange()"
										></p-selectButton>
									</div>
									<div class="col-md-6 p-2">
										<label>Vendor Form Change Request</label>
										<div
											*ngIf="configForm.vendorFormChangeRequestType.value !== 'groups'"
											class="form-group"
											[ngClass]="{ 'has-error': !configForm.vendorFormChangeRequest.valid && clientConfigSubmitted }"
										>
											<select class="form-control" formControlName="vendorFormChangeRequest">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.id" *ngFor="let item of users">
													{{ item.firstName }} {{ item.middleName }}
													{{ item.lastName }}
												</option>
											</select>
										</div>
										<div
											*ngIf="configForm.vendorFormChangeRequestType.value == 'groups'"
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.vendorFormChangeRequestGroupId.valid && clientConfigSubmitted
											}"
										>
											<select class="form-control" formControlName="vendorFormChangeRequestGroupId">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.oldId" *ngFor="let item of groups">
													{{ item.name }}
												</option>
											</select>
										</div>
										<p-selectButton
											[options]="types"
											formControlName="vendorFormChangeRequestType"
											optionLabel="label"
											optionValue="value"
											(onChange)="onVendorFormChangeRequestTypeChange()"
										></p-selectButton>
									</div>
									<div class="col-md-6 p-2">
										<label>Customer Billing Portal User</label>
										<div
											*ngIf="configForm.customerBillingPortalType.value !== 'groups'"
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.customerBillingPortalUserId.valid && clientConfigSubmitted
											}"
										>
											<select class="form-control" formControlName="customerBillingPortalUserId">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.id" *ngFor="let item of users">
													{{ item.firstName }} {{ item.middleName }}
													{{ item.lastName }}
												</option>
											</select>
										</div>
										<div
											*ngIf="configForm.customerBillingPortalType.value === 'groups'"
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.customerBillingPortalGroupId.valid && clientConfigSubmitted
											}"
										>
											<select class="form-control" formControlName="customerBillingPortalGroupId">
												<option [ngValue]="''">-Select-</option>
												<option [ngValue]="item.oldId" *ngFor="let item of groups">
													{{ item.name }}
												</option>
											</select>
										</div>
										<p-selectButton
											[options]="types"
											formControlName="customerBillingPortalType"
											optionLabel="label"
											optionValue="value"
											(onChange)="onCustomerBillingPortalTypeChange()"
										></p-selectButton>
									</div>
									<div class="col-md-6 p-2">
										<label>Do You Want AutoPay Enabled?</label>
										<div class="form-group row">
											<div class="form-check-radio col-md-5 pad-desktop">
												<label
													class="form-check-label"
													[ngClass]="{
														'text-danger': !configForm.purchasingPaymentsEnabled.valid && clientConfigSubmitted
													}"
												>
													<input
														class="form-check-input"
														type="radio"
														formControlName="purchasingPaymentsEnabled"
														id="purchasingPaymentsEnabled"
														value="true"
													/>
													On
													<span class="form-check-sign"></span>
												</label>
											</div>
											<div class="form-check-radio col-md-5">
												<label
													class="form-check-label"
													[ngClass]="{
														'text-danger': !configForm.purchasingPaymentsEnabled.valid && clientConfigSubmitted
													}"
												>
													<input
														class="form-check-input"
														type="radio"
														formControlName="purchasingPaymentsEnabled"
														id="purchasingPaymentsDisabled"
														value="false"
													/>
													Off
													<span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-6 p-2" [hidden]="configForm.purchasingPaymentsEnabled.value === 'false'">
										<label>Do You Want AutoPay Default On or Off?</label>
										<div class="form-group row">
											<div class="form-check-radio col-md-5 pad-desktop">
												<label
													class="form-check-label"
													[ngClass]="{
														'text-danger': !configForm.purchasingPaymentsDefaultValue.valid && clientConfigSubmitted
													}"
												>
													<input
														class="form-check-input"
														type="radio"
														formControlName="purchasingPaymentsDefaultValue"
														id="purchasingPaymentsDefaultValueEnabled"
														value="true"
													/>
													On
													<span class="form-check-sign"></span>
												</label>
											</div>
											<div class="form-check-radio col-md-5">
												<label
													class="form-check-label"
													[ngClass]="{
														'text-danger': !configForm.purchasingPaymentsDefaultValue.valid && clientConfigSubmitted
													}"
												>
													<input
														class="form-check-input"
														type="radio"
														formControlName="purchasingPaymentsDefaultValue"
														id="purchasingPaymentsDefaultValueDisabled"
														value="false"
													/>
													Off
													<span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-6 p-2">
										<label>Check Service Type</label>
										<div
											class="form-group"
											[ngClass]="{ 'has-error': !configForm.checkServiceType.valid && clientConfigSubmitted }"
										>
											<select class="form-control" formControlName="checkServiceType">
												<option value="">-Select-</option>
												<option value="Manual">Manual</option>
												<option value="SmartPayables">Smart Payables</option>
											</select>
										</div>
									</div>
									<div class="col-md-6 p-2">
										<label>Travel Reimbursement Rate</label>
										<div
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.travelMileageRate.valid && clientConfigSubmitted
											}"
										>
											<input type="number" class="form-control" formControlName="travelMileageRate" />
										</div>
									</div>
									<div class="col-md-6 p-2">
										<label>Mileage Reimbursement Rate</label>
										<div
											class="form-group"
											[ngClass]="{
												'has-error': !configForm.reimbursementMileageRate.valid && clientConfigSubmitted
											}"
										>
											<input type="number" class="form-control" formControlName="reimbursementMileageRate" />
										</div>
									</div>
								</div>

								<button type="submit" (click)="onClientConfigSubmit()" class="btn btn-info btn-round">Save</button>
							</form>
						</p-tabPanel>
						<p-tabPanel header="Client Logo/Module Contact Configuration" [disabled]="!item.id">
							<form
								novalidate
								(ngSubmit)="onClientLogoDetailSubmit()"
								[formGroup]="clientLogoDetailForm"
								class="form-horizontal"
							>
								<div class="row">
									<div class="col-md-12 col-lg-12" style="margin-bottom: 30px">
										<app-logo-upload
											[logoUrl]="previewUrl"
											(fileSelected)="onLogoSelected($event)"
											[ngClass]="{ 'has-error': clientLogoDetailForm.controls.logoUrl.invalid && logoDetailSubmitted }"
										></app-logo-upload>
									</div>
									<div class="col-md-6 col-lg-6">
										<label> Purchasing Contact Email</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="purchasingContactEmail"
												placeholder="Purchasing Contact Email"
											/>
										</div>
									</div>
									<div class="col-md-6 col-lg-6">
										<label> Purchasing Address</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="purchasingAddress"
												placeholder="Purchasing Address"
											/>
										</div>
									</div>
									<div class="col-md-6 col-lg-6">
										<label>Customer Contact Email </label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="customerContactEmail"
												placeholder="Customer Contact Email"
											/>
										</div>
									</div>
									<div class="col-md-6 col-lg-6">
										<label>Customer Contact Address</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="customerContactAddress"
												placeholder="Customer Contact Address"
											/>
										</div>
									</div>
									<div class="col-md-6 col-lg-6">
										<label>Vendor Portal</label>
										<div class="form-group row">
											<div class="form-check-radio col-md-4 pad-desktop">
												<label class="form-check-label">
													<input
														class="form-check-input"
														type="radio"
														formControlName="isVendorPortal"
														id="isVendorPortal"
														[value]="true"
													/>
													Yes <span class="form-check-sign"></span>
												</label>
											</div>
											<div class="form-check-radio col-md-5 pad-desktop">
												<label class="form-check-label">
													<input
														class="form-check-input"
														type="radio"
														formControlName="isVendorPortal"
														id="isVendorPortal"
														[value]="false"
													/>
													No <span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-6 col-lg-6">
										<label>Billing Portal</label>
										<div class="form-group row">
											<div class="form-check-radio col-md-4 pad-desktop">
												<label class="form-check-label">
													<input
														class="form-check-input"
														type="radio"
														formControlName="isBillingPortal"
														id="isBillingPortal"
														[value]="true"
													/>
													Yes <span class="form-check-sign"></span>
												</label>
											</div>
											<div class="form-check-radio col-md-5 pad-desktop">
												<label class="form-check-label">
													<input
														class="form-check-input"
														type="radio"
														formControlName="isBillingPortal"
														id="isBillingPortal"
														[value]="false"
													/>
													No <span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-6 col-lg-6">
										<label>Send Vendor Registration Confirmation Email</label>
										<div class="form-group row">
											<div class="form-check-radio col-md-4 pad-desktop">
												<label class="form-check-label">
													<input
														class="form-check-input"
														type="radio"
														formControlName="sendVendorRegistrationEmail"
														id="sendVendorRegistrationEmailYes"
														[value]="true"
													/>
													Yes <span class="form-check-sign"></span>
												</label>
											</div>
											<div class="form-check-radio col-md-5 pad-desktop">
												<label class="form-check-label">
													<input
														class="form-check-input"
														type="radio"
														formControlName="sendVendorRegistrationEmail"
														id="sendVendorRegistrationEmailNo"
														[value]="false"
													/>
													No <span class="form-check-sign"></span>
												</label>
											</div>
										</div>
									</div>
									<div class="col-md-6 col-lg-6" *ngIf="clientLogoDetailForm.get('isVendorPortal')?.value === true">
										<label class="required">Vendor Portal URL</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="vendorPortalUrl"
												placeholder="Vendor Portal URL"
											/>
										</div>
									</div>
									<div class="col-md-6 col-lg-6" *ngIf="clientLogoDetailForm.get('isBillingPortal')?.value === true">
										<label class="required">Billing Portal URL</label>
										<div class="form-group">
											<input
												type="text"
												class="form-control"
												formControlName="billingPortalUrl"
												placeholder="Billing Portal URL"
											/>
										</div>
									</div>
								</div>
								<div class="card-footerp-l-r-0">
									<button
										type="submit"
										[disabled]="clientLogoDetailForm.invalid || clientLogoDetailForm.disabled"
										class="btn btn-info btn-round"
									>
										{{ item.id ? 'Save' : 'Submit' }}
									</button>
								</div>
								<div class="row">
									<div *ngIf="userService.isAdmin() && canGenerateTaxBandit" class="col-md-2 pull-right">
										<button (click)="generateTaxBandit()" class="btn btn-sm mb10">Generate Tax Bandit Business</button>
									</div>
								</div>
							</form>
						</p-tabPanel>
					</p-tabView>
				</div>
			</div>
			<!-- end card -->
		</div>
		<!-- end col-md-12 -->
	</div>
	<div class="row" [hidden]="item.id === null">
		<div class="col-md-12">
			<div class="card">
				<div class="card-body">
					<section>
						<p-tabView>
							<p-tabPanel header="Available Modules">
								<div class="row">
									<div id="accordion" role="tablist" aria-multiselectable="true" class="card-collapse col-12">
										<div class="row">
											<div
												class="card card-plain col-sm-12 col-md-6"
												*ngFor="let group of groupedForms"
												[hidden]="group.items.length == 0"
											>
												<div class="card-header" role="tab" id="heading{{ group.id }}">
													<div class="row justify-content-center">
														<a
															data-toggle="collapse"
															data-parent="#accordion"
															href="#content-{{ group.id }}"
															aria-expanded="false"
															(click)="updateSection(group.id)"
															[attr.aria-controls]="'content-' + group.id"
														>
															<h6>{{ group.name }}</h6>
														</a>
													</div>
												</div>
												<div
													id="content-{{ group.id }}"
													class="collapse show"
													role="tabpanel"
													[attr.aria-labelledby]="'heading' + group.id"
												>
													<p-tabView>
														<p-tabPanel header="Forms">
															<table class="table" *ngIf="itemsOfType(group.items, 'form').length">
																<thead>
																	<tr>
																		<th>Name</th>
																		<th>Enabled</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let aitem of itemsOfType(group.items, 'form')">
																		<td>
																			{{ aitem.name }}
																			<em *ngIf="aitem.clientIds">({{ aitem.clientIds?.join(', ') }})</em>
																		</td>
																		<td>
																			<div class="form-check">
																				<label class="form-check-label">
																					<input
																						[id]="aitem?.id"
																						type="checkbox"
																						[(ngModel)]="aitem.isEnabled"
																						[checked]="aitem?.isEnabled ? 'checked' : false"
																					/>
																					<span class="form-check-sign"></span>
																				</label>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</p-tabPanel>
														<p-tabPanel header="Data Management">
															<table class="table" *ngIf="itemsOfType(group.items, 'data-management').length">
																<thead>
																	<tr>
																		<th>Name</th>
																		<th>Enabled</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let aitem of itemsOfType(group.items, 'data-management')">
																		<td>
																			{{ aitem.name }}
																			<em *ngIf="aitem.clientIds">({{ aitem.clientIds?.join(', ') }})</em>
																		</td>
																		<td>
																			<div class="form-check">
																				<label class="form-check-label">
																					<input
																						[id]="aitem?.id"
																						type="checkbox"
																						[(ngModel)]="aitem.isEnabled"
																						[checked]="aitem?.isEnabled ? 'checked' : false"
																					/>
																					<span class="form-check-sign"></span>
																				</label>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</p-tabPanel>
														<p-tabPanel header="Reports">
															<table class="table" *ngIf="itemsOfType(group.items, 'report').length">
																<thead>
																	<tr>
																		<th>Name</th>
																		<th>Enabled</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let aitem of itemsOfType(group.items, 'report')">
																		<td>
																			{{ aitem.name }}
																			<em *ngIf="aitem.clientIds">({{ aitem.clientIds?.join(', ') }})</em>
																		</td>
																		<td>
																			<div class="form-check">
																				<label class="form-check-label">
																					<input
																						[id]="aitem?.id"
																						type="checkbox"
																						[(ngModel)]="aitem.isEnabled"
																						[checked]="aitem?.isEnabled ? 'checked' : false"
																					/>
																					<span class="form-check-sign"></span>
																				</label>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</p-tabPanel>
														<p-tabPanel *ngIf="hasItems(group.items, 'type', 'link')" header="Links">
															<table class="table">
																<thead>
																	<tr>
																		<th>Name</th>
																		<th>Enabled</th>
																	</tr>
																</thead>
																<tbody>
																	<tr *ngFor="let aitem of itemsOfType(group.items, 'link')">
																		<td>
																			{{ aitem.name }}
																			<em *ngIf="aitem.clientIds">({{ aitem.clientIds?.join(', ') }})</em>
																		</td>
																		<td>
																			<div class="form-check">
																				<label class="form-check-label">
																					<input
																						[id]="aitem?.id"
																						type="checkbox"
																						[(ngModel)]="aitem.isEnabled"
																						[checked]="aitem?.isEnabled ? 'checked' : false"
																					/>
																					<span class="form-check-sign"></span>
																				</label>
																			</div>
																		</td>
																	</tr>
																</tbody>
															</table>
														</p-tabPanel>
													</p-tabView>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div class="row">
									<div class="col-3">
										<button type="button" class="btn btn-info btn-round" (click)="saveForms()">
											Save Enabled Forms
										</button>
									</div>
								</div>
							</p-tabPanel>
							<p-tabPanel header="Standalones" *ngIf="item.id">
								<div class="row" style="margin-top: 30px">
									<div class="col-12">
										<table class="table">
											<thead>
												<tr>
													<th>Product</th>
													<th>On for this client</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let product of standaloneProducts">
													<td>{{ product.name }}</td>
													<td>
														<div class="form-check">
															<label class="form-check-label">
																<input
																	type="checkbox"
																	[checked]="product.enabled"
																	(change)="setStandaloneEnabled(product, $any($event.target).checked)"
																/>
																<span class="form-check-sign"></span>
															</label>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
										<h5 class="mt-4">Who has access</h5>
										<p>Users who hold a claim on a product that is on.</p>
										<table class="table">
											<thead>
												<tr>
													<th>User</th>
													<th *ngFor="let product of standaloneProducts">
														{{ product.name }}
														<span *ngIf="product.enabled">On</span>
														<span *ngIf="!product.enabled">Off</span>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let person of usersWithStandaloneAccess()">
													<td>{{ person.name }}</td>
													<td *ngFor="let product of standaloneProducts">
														{{ standaloneAccessLabel(person, product) }}
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</p-tabPanel>
						</p-tabView>
					</section>
				</div>
			</div>
		</div>
	</div>
</div>
